import { FormProvider, useForm } from "react-hook-form";
import { FormStepper } from "./components/form-stepper/FormStepper";
import { AddStore } from "./steps/AddStore";
import { Authorization } from "./steps/Authorization";
import { Box, Container, Button, Typography } from "@mui/material";
import { useTranslation } from "../../../hooks/useTranslation";
import { Navigate, useSearchParams } from "react-router-dom";
import { AuthorizationCallback } from "./steps/AuthorizationCallback";
import { Country } from "../../../store/useMarketplaceStore";

export type StoreFormData = {
  name: string;
  country: Country | null;
  step: number;
};

export const CreateStore = () => {
  const { translate } = useTranslation("pages.stores.create");

  const [searchParams] = useSearchParams();
  const apiCode = searchParams.get("spapi_oauth_code");

  const methods = useForm<StoreFormData>({
    defaultValues: { name: "", country: null, step: 0 },
  });

  const { handleSubmit, setValue, watch } = methods;

  const currentStep = watch("step");

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <AddStore />;
      case 1:
        return <Authorization />;
      default:
        return <Navigate to="store/create" />;
    }
  };

  if (apiCode) {
    return <AuthorizationCallback />;
  }

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        autoComplete="off"
        onSubmit={handleSubmit(() =>
          setValue("step", currentStep == 1 ? 0 : 1),
        )}
      >
        <FormStepper />

        {getStepContent(currentStep)}

        <Container
          sx={{
            padding: "12px 0px",
            justifyContent: currentStep === 1 ? "start" : "end",
            display: "flex",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{ width: "150px" }}
          >
            <Typography variant="button">
              {translate(
                currentStep === 1 ? "actions.previous" : "actions.next",
              )}
            </Typography>
          </Button>
        </Container>
      </Box>
    </FormProvider>
  );
};
